/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
    PalAuthSubmissionStatusToJSONTyped,
} from './PalAuthSubmissionStatus';

/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusInfo
 */
export interface PalAuthSubmissionStatusInfo {
    /**
     * 
     */
    status: PalAuthSubmissionStatus;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    level?: string;
    /**
     * 
     */
    status_override?: PalAuthSubmissionStatusInfoStatusOverrideEnum;
    /**
     * 
     */
    contact_status?: PalAuthSubmissionStatusInfoContactStatusEnum;
    /**
     * 
     */
    outcome?: PalAuthSubmissionStatusInfoOutcomeEnum;
}


/**
 * @export
 */
export const PalAuthSubmissionStatusInfoStatusOverrideEnum = {
    BenefitsVerified: 'benefits_verified',
} as const;
export type PalAuthSubmissionStatusInfoStatusOverrideEnum = typeof PalAuthSubmissionStatusInfoStatusOverrideEnum[keyof typeof PalAuthSubmissionStatusInfoStatusOverrideEnum];

/**
 * @export
 */
export const PalAuthSubmissionStatusInfoContactStatusEnum = {
    Contacted: 'contacted',
    DidNotReach: 'did_not_reach',
} as const;
export type PalAuthSubmissionStatusInfoContactStatusEnum = typeof PalAuthSubmissionStatusInfoContactStatusEnum[keyof typeof PalAuthSubmissionStatusInfoContactStatusEnum];

/**
 * @export
 */
export const PalAuthSubmissionStatusInfoOutcomeEnum = {
    RevisedAuth: 'revised_auth',
    WouldNotContactPayer: 'would_not_contact_payer',
    AttemptedUnableToReach: 'attempted_unable_to_reach',
    DidNotAttempt: 'did_not_attempt',
} as const;
export type PalAuthSubmissionStatusInfoOutcomeEnum = typeof PalAuthSubmissionStatusInfoOutcomeEnum[keyof typeof PalAuthSubmissionStatusInfoOutcomeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionStatusInfo interface.
 */
export function instanceOfPalAuthSubmissionStatusInfo(value: object): value is PalAuthSubmissionStatusInfo {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PalAuthSubmissionStatusInfoFromJSON(json: any): PalAuthSubmissionStatusInfo {
    return PalAuthSubmissionStatusInfoFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PalAuthSubmissionStatusFromJSON(json['status']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'level': json['level'] == null ? undefined : json['level'],
        'status_override': json['status_override'] == null ? undefined : json['status_override'],
        'contact_status': json['contact_status'] == null ? undefined : json['contact_status'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
    };
}

export function PalAuthSubmissionStatusInfoToJSON(json: any): PalAuthSubmissionStatusInfo {
    return PalAuthSubmissionStatusInfoToJSONTyped(json, false);
}

export function PalAuthSubmissionStatusInfoToJSONTyped(value?: PalAuthSubmissionStatusInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': PalAuthSubmissionStatusToJSON(value['status']),
        'comment': value['comment'],
        'level': value['level'],
        'status_override': value['status_override'],
        'contact_status': value['contact_status'],
        'outcome': value['outcome'],
    };
}

